import { useQuery } from '@tanstack/react-query';

import { getDashboardStats } from '@/api/apiDashboard';

export function useDashboardStats(enabled = true) {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: getDashboardStats,
    enabled,
  });
}
